import React from 'react';
import { Link } from 'react-router-dom';
import './Cosection.css';
import questionn from "../images/img1.gif";

const Cosection = () => {
  return (
    <div className="cosection-contact-container">
      <div>
        <img src={questionn} alt="Question illustration" className="cosection-img-question" />
      </div>
      <div className="cosection-contact-content">
        <h2 className="cosection-title">Have any questions?</h2>
        <p className="cosection-description">
          Feel free to reach out to us for any inquiries or support!
        </p>
        <Link to="/contactusform">
          <button className="cosection-contact-btn">Contact Us</button>
        </Link>
      </div>
    </div>
  );
};

export default Cosection;